import logo from '../assets/logo.png'
import { useNavigate } from 'react-router-dom'

function Footer() {
    const navigate = useNavigate()
    const onSigninHandler = () => {
        navigate('/signin')
    }
    return (
        <div className='flex justify-between px-4 justify-self-end bg-slate-300 w-full py-2'>
            <div className='flex items-center'>
                <span className='text-[12px] sm:text-[16px]'>©2025</span>
            </div>
            <div className='flex gap-4 items-center'>
                <span className='text-[12px] sm:text-[16px]'>Powered By Titanforge Technologies</span>
                <img src={logo} alt='' className='w-10 h-10 cursor-pointer' onClick={onSigninHandler} />
            </div>
        </div>
    )
}

export default Footer